import { FC, PropsWithChildren } from "react";

type Props = {
  showPlaceholder: boolean;
};

const DetailsPagePlaceholderContainer: FC<PropsWithChildren<Props>> = ({
  showPlaceholder = true,
  children
}) => (
  <div className={`details-page-placeholder-${showPlaceholder ? "on" : "off"}`}>
    {children}
  </div>
);

export default DetailsPagePlaceholderContainer;
